import { DraftPrescriptionDisplayIndex, Prescription } from '../types';

export const getDraftDisplayIndex = (
   existingPrescriptions: Pick<Prescription, 'displayIndex'>[],
   draftsCount: number,
   draftIndex: number
): DraftPrescriptionDisplayIndex => {
   const nextDisplayIndex = Math.max(-1, ...existingPrescriptions.map((prescription) => prescription.displayIndex)) + 1;
   return nextDisplayIndex + draftsCount - 1 - draftIndex;
};
